import { render, staticRenderFns } from "./HeaderActionPlan.vue?vue&type=template&id=36a7f456&scoped=true&"
import script from "./HeaderActionPlan.ts?vue&type=script&lang=ts&"
export * from "./HeaderActionPlan.ts?vue&type=script&lang=ts&"
import style0 from "./HeaderActionPlan.scss?vue&type=style&index=0&id=36a7f456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7f456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSwitch,VTextField})
